import useAxiosInterceptor from 'src/services/interceptor';
import { MyAvailability } from '../constants';
class MyAvailabilityServices {
  private axiosInstance;

  constructor() {
    this.axiosInstance = useAxiosInterceptor();
  }

  getMyAvailability = (payload: any) => {
    return this.axiosInstance.get(
      `${MyAvailability.getMyAvailability}/${payload.providerId}?start=${payload.startDate}&end=${payload.endDate}`
    );
  };

  editMyAvailability = (payload: any) => {
    return this.axiosInstance.put(
      `${MyAvailability.editAvailability}/${payload.providerId}?startRange=${payload.startDate}&endRange=${payload.endDate}`,
      payload.data
    );
  };

  getTherapistAvail = () => {
    return this.axiosInstance.get(`${MyAvailability.getTherapistList}`);
  };
}

const myAvailabilityServices = new MyAvailabilityServices();

Object.freeze(myAvailabilityServices);

export default myAvailabilityServices;
